import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';

@Component({
  selector: 'md-subheader-tab',
  templateUrl: 'subheader-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubheaderTabComponent extends BaseComponent implements OnChanges {
  // @ts-expect-error
  private activeValue: boolean;

  // @ts-expect-error
  @Input() disabled: boolean;
  @Input() id: any;
  @Input()
  get active(): boolean {
    return this.activeValue;
  }
  set active(value: boolean) {
    this.activeValue = value;
    this.activeChange.emit(value);
    this.cdr.markForCheck();
  }
  activeIdValue: any;
  @Input()
  set activeId(value: any) {
    this.activeIdValue = value;
    this.active = this.activeId === this.id;
  }
  get activeId() {
    return this.activeIdValue;
  }

  @Output() activeChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() tabClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  @ViewChild('container', { static: true })
  container?: ElementRef<HTMLDivElement>;

  // @ts-expect-error
  @HostBinding('style.pointer-events') tabDisabled: string;

  @HostListener('click', ['$event']) click(e: MouseEvent) {
    this.tabClick.emit(e);
  }

  constructor(readonly cdr: ChangeDetectorRef) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled) {
      // @ts-expect-error
      this.tabDisabled = this.disabled ? 'none' : null;
    }
  }

  getDimensions(): { width: number; left: number } {
    return {
      width: this.container?.nativeElement.offsetWidth || 0,
      left: this.container?.nativeElement.offsetLeft || 0,
    };
  }
}
